import { render, staticRenderFns } from "./TipoAssinaturaWhatsapp.vue?vue&type=template&id=3fce21b1"
import script from "./TipoAssinaturaWhatsapp.vue?vue&type=script&lang=js"
export * from "./TipoAssinaturaWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./TipoAssinaturaWhatsapp.vue?vue&type=style&index=0&id=3fce21b1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports